import _extends from "@babel/runtime-corejs3/helpers/extends";import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";import React from 'react';
import clsx from 'clsx';
import { capitalize } from "../../helpers";

import { createStyles } from "./styles";

/**
 * There are two types of props that define visual representation of the Button component: `type` and `color`.
 * The `type` stands for the general button appearance and `color` defines it's base color and shadows. But keep
 * in mind that not all the types are compatible to all the colors values. If you pass the `type` and `color` props,
 * that are incompatible - the button will be of contained `type` and primary `color` , this is the default visual
 * representation. Check the matrix of compatible types and colors lower.
 *
 * ***Color types compatibility***
 *
 * |             | Contained | Outlined | Text | Opaque | Icon |
 * | ----------- | :-------: | :------: | :--: | :----: | :--: |
 * | **Primary** |     +     |    +     |  +   |   +    |  +   |
 * | **Default** |     +     |    +     |  +   |   +    |  +   |
 * | **Custom**  |     +     |    +     |  +   |   -    |  +   |
 *
 * ***Button sizes***
 *
 * |            |               Text               |           Others             |
 * | ---------- | :------------------------------: | :--------------------------: |
 * | **Small**  | lineHeight: 24px, fontSize: 14px | height: 32px, fontSize: 12px |
 * | **Medium** | lineHeight: 24px, fontSize: 18px | height: 36px, fontSize: 14px |
 * | **Large**  | lineHeight: 32px, fontSize: 24px | height: 44px, fontSize: 14px |
 */
var Button = /*#__PURE__*/React.forwardRef(function (props, ref) {var _context, _context2;
  var
    id =













    props.id,name = props.name,children = props.children,onClick = props.onClick,_props$type = props.type,type = _props$type === void 0 ? 'contained' : _props$type,_props$size = props.size,size = _props$size === void 0 ? 'small' : _props$size,_props$color = props.color,color = _props$color === void 0 ? 'default' : _props$color,leftIconProp = props.leftIconProp,rightIconProp = props.rightIconProp,_props$htmlType = props.htmlType,htmlType = _props$htmlType === void 0 ? 'button' : _props$htmlType,htmlForm = props.htmlForm,disabled = props.disabled,dataSet = props.dataSet,className = props.className;
  var classes = createStyles(props);
  var leftIcon = leftIconProp && /*#__PURE__*/
  React.createElement("span", { className: clsx(classes.iconProp, classes.leftIconProp) }, leftIconProp);

  var rightIcon = rightIconProp && /*#__PURE__*/
  React.createElement("span", { className: clsx(classes.iconProp, classes.rightIconProp) }, rightIconProp);


  var passedOrDefaultColorType = classes[_concatInstanceProperty(_context = "".concat(type)).call(_context, capitalize(color))] ? _concatInstanceProperty(_context2 = "".concat(
  type)).call(_context2, capitalize(color)) :
  'containedPrimary';

  var passedOrDefaultSize = classes[size] ? size : 'small';
  return /*#__PURE__*/(
    React.createElement("button", _extends({
      id: id,
      name: name,
      onClick: onClick
      // Eslint does not recognize dynamic html button type attribute assigning for some reason.
      // eslint-disable-next-line react/button-has-type
      , type: htmlType,
      form: htmlForm,
      disabled: disabled,
      className: clsx(
      classes.button,
      // Applying color classes if there is no disabled prop activated.
      disabled !== true && classes[passedOrDefaultColorType],
      // Apply default disabled styles if the button is inactivated.
      disabled === true && classes.inactiveButton,
      // Apply the 'text' type button css styles if the button is of the 'text' type.
      type === 'text' && classes["text".concat(capitalize(passedOrDefaultSize))],
      // Apply the sizes classes only if button is not of the 'text' or 'icon' type.
      type !== 'text' && type !== 'icon' && classes[passedOrDefaultSize],
      // Apply the icon props styles.
      rightIconProp && leftIconProp && classes.withIcons,
      // Apply custom styles properties.
      type === 'icon' && classes.iconButton,
      // Apply 'iconSize' prop if the Button is of type 'icon'.
      className),

      ref: ref },
    dataSet),

    leftIcon,
    children,
    rightIcon));


});
Button.displayName = 'Button';

export default Button;
//# sourceMappingURL=index.js.map